export const currentStep = 0

export const stepStatus = {
    step1: false,
    step2: false,
    step3: false,
    step4: false,
    step5: false,
    step6: false,
    step7: false,
    step8: false,
    step9: false,
    step10: false,
    step11: false,
    step12: false,
    step13: false,
    step14: false,
    step15: false,
}

// 導線の分岐でスキップしたステップのindexを保持する（通常の遷移では常に空配列）
export const skippedSteps: number[] = []
